// extracted by mini-css-extract-plugin
module.exports = {"contact":"footer-module--contact--2FziM","footer":"footer-module--footer--V5wV3"};